import { CheckCircle, CircleX } from "lucide-react";

const PasswordCheckComponent = (props: {
  hasDigits: boolean;
  isLengthValid: boolean;
  isUpperCase: boolean;
  isLowerCase: boolean;
  hasSymbols: boolean;
  hasSpaces: boolean;
}) => {
  return (
    <div
      style={{
        marginTop: "16px",
        marginBottom: "8px",
        border: "1px solid #e0e0e0",
        padding: "12px",
        borderRadius: "4px",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
          marginBottom: "8px",
          color: "#666",
        }}
      >
        Password Requirements:
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.isLengthValid ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.isLengthValid ? "#4caf50" : "#f44336",
          }}
        >
          Contains 8-20 characters
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.isUpperCase ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.isUpperCase ? "#4caf50" : "#f44336",
          }}
        >
          Contains uppercase letter
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.isLowerCase ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.isLowerCase ? "#4caf50" : "#f44336",
          }}
        >
          Contains lowercase letter
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.hasDigits ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.hasDigits ? "#4caf50" : "#f44336",
          }}
        >
          Contains number
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.hasSymbols ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.hasSymbols ? "#4caf50" : "#f44336",
          }}
        >
          Contains symbol
        </span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        {props.hasSpaces ? (
          <CheckCircle
            style={{
              color: "#4caf50",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        ) : (
          <CircleX
            style={{
              color: "#f44336",
              fontSize: "16px",
              marginRight: "8px",
            }}
          />
        )}
        <span
          style={{
            fontSize: "12px",
            color: props.hasSpaces ? "#4caf50" : "#f44336",
          }}
        >
          No spaces
        </span>
      </div>
    </div>
  );
};

export { PasswordCheckComponent };
